// datetime-local displays browser-local time; the DTO retains an unambiguous instant.
export function cutoffForInput(value) {
  if (!value) return '';
  // Preserve existing timezone-less DTO values until the user edits them.
  if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function cutoffFromInput(value) {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
}
